import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Placeholder from 'components/Shared/Common/Placeholder';
import { SEARCH_INPUT_MIN_LENGTH } from 'const/input';
import styled from 'styled-components';
import { contact as Item } from 'components/Shared/User/Item/container';
import SearchBar from 'components/Shared/Forms/SearchBar';
import { CONTACT_STATUS } from 'const/user';
import withCursor from 'hoc/withCursor';
import ContactList from 'components/Shared/Contacts/ContactList';
import ContactActions from '../User/Item/ContactActions';

const SearchContainer = styled.div`
    padding-bottom: 20px;
`;

const formatMessages = intl => () => ({
    searchInputPlaceholder: intl.formatMessage({
        id: 'drawer.search.input.placeholder',
        defaultMessage: 'Votre recherche'
    }),
    searchError: intl.formatMessage({
        id: 'drawer.search.input.errorMessage',
        defaultMessage: 'Votre recherche doit dépasser les 2 caractères.'
    }),
    searchFallBackMessage: intl.formatMessage({
        id: 'rightColumn.contacts.searchFallBackMessage',
        defaultMessage: 'Aucun résultat ne correspond à votre recherche.'
    }),
    placeholderTitle: intl.formatMessage({
        id: 'drawer.search.fallbackMessage.title',
        defaultMessage: 'Tapez dans la barre de recherche'
    }),
});

const SearchableContactList = ({
    intl,
    openSearchDrawer,
    contactStatus,
    isInitiator,
    ItemComponent,
    isExpanded = true,
    ...rest
}) => {
    const i18n = formatMessages(intl)();
    const [query, setQuery] = useState();

    const handleSearch = useCallback((e) => setQuery(e), [setQuery]);
    const handleClear = useCallback(() => setQuery(''), [setQuery]);
    const MyPlaceholder = openSearchDrawer ? withCursor(Placeholder) : Placeholder;

    const handleRenderAction = ({ _user, contactStatus, isInitiator }) => (
        <ContactActions
            _user={_user}
            contactStatus={contactStatus}
            isInitiator={isInitiator}
            size="md"
        />
    );

    const ContactItem = (props) => (
        <Item
            {...props}
            _user={props.id}
            avatarSize="md"
            actionRender={handleRenderAction}
        />
    );

    return (
        <>
            <SearchContainer className="search">
                <SearchBar
                    onSearch={handleSearch}
                    onClear={handleClear}
                    debounceDuration={500}
                    placeholder={i18n.searchInputPlaceholder}
                    autoFocus
                />
            </SearchContainer>
            <ContactList
                query={query}
                contactStatus={contactStatus}
                isInitiator={isInitiator}
                pageSize={48}
                ItemComponent={ItemComponent || ContactItem}
                displayMode="list"
                hasShowMore
                noItemFallback={isExpanded ? (
                    <MyPlaceholder
                        onClick={openSearchDrawer}
                        name="placeholderSuggestions"
                        position="centered"
                        title={
                            query?.length >= SEARCH_INPUT_MIN_LENGTH
                                ? intl.formatMessage({ id: 'rightColumn.contacts.searchFallBackMessage',
                                    defaultMessage: 'Aucun résultat ne correspond à votre recherche.'
                                })
                                : intl.formatMessage({ id: 'drawer.search.fallbackMessage.title',
                                    defaultMessage: 'Tapez dans la barre de recherche'
                                })
                        }
                        subTitle={intl.formatMessage({ id: 'drawer.createUnicastFeed.fallbackMessage.subtitle',
                            defaultMessage: 'N\'hésitez pas à ajouter de nouvelles relations.'
                        })}
                    />
                ) : null}
                {...rest}
            />
        </>
    );
};

SearchableContactList.propTypes = {
    intl: PropTypes.any.isRequired,
    openSearchDrawer: PropTypes.func,
    contactStatus: PropTypes.oneOf(Object.values(CONTACT_STATUS)),
    isInitiator: PropTypes.bool,
    isExpanded: PropTypes.bool
};

export default injectIntl(SearchableContactList);

